import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Get insights into luxury cruising with First-Class.com. Explore articles on cruise experiences, destinations, and onboard amenities'
          }
        />
        <title>Cruise Articles: In-Depth Cruise Insights</title>
      </Head>
      <ArticlesList subtype="Articles" type="Cruises" />
    </>
  );
}

export default withLayout(Articles, true);
